export const CACHE_KD_FILTER = 'kd_filters'
export const CACHE_KD_TENANT = 'kd_tenant'
